<template>
  <div class="benefits">
    <b-row>
      <b-col
        v-for="(perk, i) in items"
        :key="i"
        lg="4"
        sm="6"
        class="benefits__items"
      >
        <div class="benefits__items__item py-24">
          <img
            class="benefits__items__item__icon"
            :src="perk.icon"
            :alt="perk.name"
          />
          <h5 class="pt-30">{{ perk.name }}</h5>
          <p class="pt-10">{{ perk.description }}</p>
        </div>
      </b-col>
    </b-row>

    <a v-if="shouldShowMoreButton" class="benefits__more" @click="onShowRest"
      >See all {{ list.length }} benefits <i class="icon icon-caret"></i
    ></a>
  </div>
</template>

<script>
import take from 'lodash/take'

export default {
  name: 'StartupsBenefits',
  props: {
    list: Array,
    max: Number
  },
  data() {
    return {
      isShowingAll: false
    }
  },
  computed: {
    shouldShowMoreButton() {
      return this.max < this.list.length && !this.isShowingAll
    },
    items() {
      let perks = this.list.map((id) =>
        this.$store.getters['meta/companyPerkById'](id)
      )

      perks = perks.filter((perk) => perk)
      // console.log('perks', perks);
      if (this.max && !this.isShowingAll) {
        return take(perks, this.max)
      }

      return perks
    }
  },
  methods: {
    onShowRest() {
      this.isShowingAll = true
    }
  }
}
</script>

<style lang="scss" scoped>
.benefits {
  &__items {
    &__item {
      &__icon {
        width: 2.5rem;
        height: 2.5rem;
        object-fit: contain;
      }

      h5 {
        color: $gray-900;
      }

      p {
        max-width: 260px;
      }
    }
  }

  &__more {
    margin-top: 2rem;
    display: inline-block;
    font-weight: 700;
    color: $blue-900 !important;
    cursor: pointer;

    & > i {
      font-size: 0.7rem;
      margin-left: 0.3rem;
    }
  }
}
</style>
